import React from 'react';

import { Tooltip, Flex } from 'antd';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { ThermometerIcon, LoaderIcon } from '@icons/index';

dayjs.extend(utc);

interface ITariffCard {
    precoolingPrice?: number;
    precoolingPriceRequired?: boolean;
    handlingPrice?: number;
    handlingPriceRequired?: boolean;
}

const TariffCard = (props: ITariffCard) => {
    const { precoolingPrice, precoolingPriceRequired, handlingPrice, handlingPriceRequired } = props;

    return (
        <div>
            {(handlingPrice || handlingPriceRequired) && (
                <Flex align='center' gap='middle' style={{ backgroundColor: handlingPrice ? '' : '#f29faf' }}>
                    <div>
                        <Tooltip
                            title={handlingPrice ? 'Хранение' : 'Укажите тариф за хранение'}
                            placement='topRight'
                            color={handlingPrice ? '' : 'var(--main-red)'}
                        >
                            <div>
                                <LoaderIcon style={{ fontSize: 14 }} />
                            </div>
                        </Tooltip>
                    </div>
                    <div>{handlingPrice}</div>
                </Flex>
            )}

            {(precoolingPrice || precoolingPriceRequired) && (
                <Flex align='center' gap='middle' style={{ backgroundColor: precoolingPrice ? '' : '#f29faf' }}>
                    <div>
                        <Tooltip
                            title={precoolingPrice ? 'Прекулинг' : 'Укажите тариф за прекулинг'}
                            placement='topRight'
                            color={precoolingPrice ? '' : 'var(--main-red)'}
                        >
                            <div>
                                <ThermometerIcon style={{ fontSize: 14 }} />
                            </div>
                        </Tooltip>
                    </div>
                    <div>{precoolingPrice}</div>
                </Flex>
            )}
        </div>
    );
};

export default TariffCard;
